import React, { useEffect, useMemo, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import { Button, Modal, Select } from "../../../components/core";
import LockerTimeLimitTable from "./components/locker-time-limit-table";
import { useDispatch, useSelector } from "react-redux";
import {
	CREATE_LOCKER_TIME,
	LOCKER_TIME_LIMIT,
	LOCKER_TYPES_FOR_LOCKER_TIME_LIMITS,
	PARTNER_TYPES_FOR_LOCKER_TIME_LIMITS,
	UPDATE_LOCKER_TIME_LIMITS,
} from "../../../constants/graphql/locker-time-limits-query";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
	changeCriteriaValue,
	changeLockerTimeLimitsData,
	clearLockerTimeLimitChanges,
	getLockerTypeList,
	getPartnertTypeList,
	resetLockerTimeLimits,
	setLockerTimeLimitsData,
} from "../../../features/locker-time-limits/locker-time-limits-slice";
import { Card } from "primereact/card";
import useSidebarStore from "../../../zustand/stores/sidebar-store";
import { useNavigate } from "react-router-dom";
import { Strings } from "../../../constants/strings";
import { ALL_PARTNER_CAREGORIES } from "../../../constants/graphql/partner-types-query";

export default function LockerTimeLimits() {
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	// Utilities
	const dispatch = useDispatch();
	const navigate = useNavigate();
	//Redux States
	const searchCriteria = useSelector(
		(state) => state.lockerTimeLimits.searchCriteria
	);
	const lockerTypeList = useSelector(
		(state) => state.lockerTimeLimits.lockerTypeList
	);
	const partnerTypeList = useSelector(
		(state) => state.lockerTimeLimits.partnerTypeList
	);
	const lockerTimeLimitsData = useSelector(
		(state) => state.lockerTimeLimits.lockerTimeLimitsData
	);

	//Graphql
	const lockerTypes = useQuery(LOCKER_TYPES_FOR_LOCKER_TIME_LIMITS);
	const partnerTypes = useQuery(PARTNER_TYPES_FOR_LOCKER_TIME_LIMITS, {
		variables: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
		},
		fetchPolicy: "no-cache",
	});

	const { data: queryCategories, loading } = useQuery(ALL_PARTNER_CAREGORIES);
	const [partnerTypesQuery] = useLazyQuery(
		PARTNER_TYPES_FOR_LOCKER_TIME_LIMITS
	);
	const [lockerTimeLimit, { refetch }] = useLazyQuery(LOCKER_TIME_LIMIT, {
		fetchPolicy: "no-cache",
	});

	// separated add and edit to avoid duplciate error
	const [createLockerTimeLimits] = useMutation(CREATE_LOCKER_TIME);
	const [updateLockerTimeLimits] = useMutation(UPDATE_LOCKER_TIME_LIMITS);
	//Local States
	const [initialLockerTimeLimit, setInitialLockerTimeLimit] = React.useState(
		{}
	);
	const [changesMade, setChangesMade] = useState(false);

	const [editingDone, setEditingDone] = useState(false);
	const [searchFlag, setSearchFlag] = React.useState(false);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	const [searchCriteriaData, setSearchCriteriaData] = React.useState({
		lockerTypeId: "",
		partnerTypeId: "",
	});

	const [valueChanged, setValueChanged] = useState(false);
	const [success, setIsSuccess] = useState(false);
	// zustand
	const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
	const setPendingNavigation = useSidebarStore(
		(state) => state.setPendingNavigation
	);
	const activeSubItem = useSidebarStore((state) => state.activeSubItem);
	const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

	const partnerCategoryList = useMemo(() => {
		if (queryCategories && queryCategories.partnerCategories) {
			return queryCategories.partnerCategories.map((category) => ({
				value: category.partnerCategoryNo,
				name: category.partnerCategory,
			}));
		}
	}, [queryCategories]);

	console.log({ queryCategories, partnerCategoryList });

	useEffect(() => {
		if (pendingNavigation !== null) {
			if (changesMade) {
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
					title: `${Strings.popup_confirm_cancel_title}?`,
					message: Strings.popup_confirm_cancel_massage,
					open: true,
					actions: (
						<div className="flex justify-between gap-3">
							<Button
								onClick={() => {
									setValidation({ open: false });
									// window.location.reload();
									setPendingNavigation(null);
									setActiveSubItem(activeSubItem);
								}}
								value={"No"}
								className={"p-2 w-full"}
							/>
							<Button
								onClick={() => {
									navigate(pendingNavigation);
									setPendingNavigation(null);
								}}
								value={"Yes"}
								className={"p-2 w-full"}
							/>
						</div>
					),
				});
			} else {
				navigate(pendingNavigation);
				setPendingNavigation(null);
			}
		}
	}, [pendingNavigation, changesMade]); // const handleChangeCriteriaValue = (event) => {
	// 	setEditingDone(false);

	// 	const { name, value } = event.target;
	// 	console.log({ name, value });

	// 	if (name === "lockerTypeId") {
	// 		// Check if the value has changed
	// 		if (searchCriteriaData.lockerTypeId !== value) {
	// 			setValueChanged(true);
	// 			setSearchFlag(false);
	// 			dispatch(changeCriteriaValue({ name: "partnerTypeId", value: "-1" }));
	// 			// Reset partner type list if lockerTypeId has changed
	// 			dispatch(getPartnertTypeList([]));
	// 		}

	// 		if (value !== "-1") {
	// 			// Update lockerTypeId and fetch new partner types
	// 			setSearchCriteriaData({
	// 				...searchCriteriaData,
	// 				lockerTypeId: value,
	// 				partnerTypeId: "",
	// 			});

	// 			partnerTypesQuery({
	// 				variables: {
	// 					operatorId: searchCriteria.operatorId,
	// 					lockerTypeId: value,
	// 				},
	// 			}).then((data) => {
	// 				if (data.data) {
	// 					const tempData = data.data.partnerTypes.map((element) => ({
	// 						value: element.partnerTypeId,
	// 						name: element.partnerType,
	// 					}));
	// 					dispatch(getPartnertTypeList(tempData));
	// 				}
	// 			});
	// 		} else {
	// 			// Handle case where value is "-1" (optional logic)
	// 			dispatch(getPartnertTypeList([]));
	// 		}
	// 	}

	// 	// Update search criteria for other fields
	// 	dispatch(changeCriteriaValue({ name: name, value: value }));
	// };

	const handleChangeCriteriaValue = (event) => {
		setEditingDone(false);

		const { name, value } = event.target; // Debug incoming value

		if (name === "lockerTypeId") {
			if (searchCriteriaData.lockerTypeId !== value) {
				setValueChanged(true);
				setSearchFlag(false);

				// Reset partnerTypeId in both local and Redux states
				dispatch(changeCriteriaValue({ name: "partnerTypeId", value: "-1" }));
				dispatch(changeCriteriaValue({ name: "partnerCategory", value: "-1" }));
				dispatch(changeCriteriaValue({ name: "lockerTypeId", value }));

				setSearchCriteriaData({
					...searchCriteriaData,
					lockerTypeId: value,
					partnerTypeId: "-1",
				});

				dispatch(getPartnertTypeList([])); // Clear partner type list

				if (value !== "-1") {
					partnerTypesQuery({
						variables: {
							operatorId: searchCriteria.operatorId,
							lockerTypeIds: value,
						},
					}).then((data) => {
						if (data.data) {
							const tempData = data.data.partnerTypes.map((element) => ({
								value: element.partnerTypeId,
								name: element.partnerType,
								partnerCategory: element.partnerCategory.partnerCategoryNo,
							}));

							dispatch(getPartnertTypeList(tempData));
						}
					});
				}
			}
		} else {
			if (searchCriteriaData.partnerTypeId !== value) {
				setValueChanged(true);
				setSearchFlag(false);
			}
		}

		// // For other fields
		// if (name !== "lockerTypeId") {
		// 	dispatch(changeCriteriaValue({ name, value }));
		// 	setSearchCriteriaData({
		// 		...searchCriteriaData,
		// 		[name]: value,
		// 	});
		// } // Debug updated state
		dispatch(changeCriteriaValue({ name, value }));
	};

	const filteredPartnerTypeByCategory = useMemo(() => {
		if (searchCriteria.partnerCategory === "-1") {
			return partnerTypeList;
		}
		return partnerTypeList.filter(
			(item) =>
				parseInt(item.partnerCategory) ===
				parseInt(searchCriteria.partnerCategory)
		);
	}, [searchCriteria.partnerCategory, partnerTypeList]);

	console.log({
		filteredPartnerTypeByCategory,
		searchCriteria,
		partnerTypeList,
	});
	// const [prevPartnerType, setPrevPartnerType] = useState("");
	const [emptyLockerTimeLim, setEmptyLockerTimeLim] = useState(false);
	const [isClicked, setIsCliked] = useState(false);
	console.log({ searchCriteria });
	const handleSearchLockerTimeLimits = () => {
		setIsCliked(true);
		if (
			// searchCriteria.lockerTypeId === "-1" ||
			searchCriteria.partnerTypeId === "-1"
		) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete search criteria",
				message: "Please input Locker Type & Partner Type.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => {
								setValidation({ open: false });
								setIsCliked(false);
							}}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		} else {
			// setPrevPartnerType({
			// 	partnerTypeId: partnerTypeList.find(
			// 		(x) => x.value === searchCriteria.partnerTypeId
			// 	).name,
			// });
			setSearchCriteriaData({
				lockerTypeId: lockerTypeList.find(
					(x) => x.value === searchCriteria.lockerTypeId
				)?.name,
				partnerTypeId: partnerTypeList.find(
					(x) => x.value === searchCriteria.partnerTypeId
				)?.name,
			});

			setSearchFlag(true);
			lockerTimeLimit({ variables: searchCriteria })
				.then((data) => {
					if (data.data) {
						if (data.data.lockerPartnerLimits.length > 0) {
							setInitialLockerTimeLimit(data.data.lockerPartnerLimits[0]);
							setEmptyLockerTimeLim(false);
							dispatch(
								setLockerTimeLimitsData(data.data.lockerPartnerLimits[0])
							);
						} else {
							setEmptyLockerTimeLim(true);

							setInitialLockerTimeLimit({
								lockerPartnerLimitId: "",
								pickupPulloutLimit: "",
								pickupTakebackLimit: "",
								shipoutBookingExpiry: "",
								shipoutPulloutLimit: "",
								shipoutTakebackLimit: "",
							});
							dispatch(
								setLockerTimeLimitsData({
									lockerPartnerLimitId: "",
									pickupPulloutLimit: "",
									pickupTakebackLimit: "",
									shipoutBookingExpiry: "",
									shipoutPulloutLimit: "",
									shipoutTakebackLimit: "",
								})
							);
						}
					}
				})
				.catch((e) => console.error({ e }));
		}
	};

	const handleChangeLockerTimeLimits = (event) => {
		setEditingDone(true);
		const { name, value } = event.target;
		setChangesMade(true);

		dispatch(changeLockerTimeLimitsData({ name: name, value: value }));
	};

	useEffect(() => {
		dispatch(resetLockerTimeLimits());
	}, []);

	const companyName = localStorage.getItem("user")
		? JSON.parse(localStorage.getItem("user")).company
		: "";

	const handleSaveChanges = () => {
		// Base validation for pickup fields (always required)
		let requiredFields = [
			lockerTimeLimitsData.pickupPulloutLimit === "",
			lockerTimeLimitsData.pickupTakebackLimit === "",
		];

		// Add shipout fields to validation only if company is MBOX
		if (companyName === "MBOX") {
			requiredFields.push(
				lockerTimeLimitsData.shipoutBookingExpiry === "",
				lockerTimeLimitsData.shipoutPulloutLimit === "",
				lockerTimeLimitsData.shipoutTakebackLimit === ""
			);
		}

		// Check if any required fields are empty
		if (requiredFields.some((field) => field)) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete Data",
				message: "Please complete all the fields.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
			return; // Exit early if validation fails
		}

		// Base validation for pickup field limits (always checked)
		let limitExceeded = [
			lockerTimeLimitsData.pickupPulloutLimit > 720,
			lockerTimeLimitsData.pickupTakebackLimit > 720,
		];

		// Add shipout field limits to validation only if company is MBOX
		if (companyName === "MBOX") {
			limitExceeded.push(
				lockerTimeLimitsData.shipoutBookingExpiry > 720,
				lockerTimeLimitsData.shipoutPulloutLimit > 720,
				lockerTimeLimitsData.shipoutTakebackLimit > 720
			);
		}

		// Check if any limits are exceeded
		if (limitExceeded.some((limit) => limit)) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Value",
				message: "Maximum hour is 720. Please recheck.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
			return; // Exit early if validation fails
		}

		// Proceed with create/update logic
		if (emptyLockerTimeLim) {
			let tempLockerTimeLimitsData = { ...lockerTimeLimitsData };
			// remove lockerPartnerLimitId
			delete tempLockerTimeLimitsData.lockerPartnerLimitId;

			console.log({ tempLockerTimeLimitsData, lockerTimeLimitsData });
			tempLockerTimeLimitsData.operatorId = searchCriteria.operatorId;
			tempLockerTimeLimitsData.lockerTypeId = searchCriteria.lockerTypeId;
			tempLockerTimeLimitsData.partnerTypeId = searchCriteria.partnerTypeId;
			tempLockerTimeLimitsData.shipoutBookingExpiry =
				lockerTimeLimitsData.shipoutBookingExpiry === ""
					? 0
					: lockerTimeLimitsData.shipoutBookingExpiry;

			tempLockerTimeLimitsData.shipoutPulloutLimit =
				lockerTimeLimitsData.shipoutPulloutLimit === ""
					? 0
					: lockerTimeLimitsData.shipoutPulloutLimit;
			tempLockerTimeLimitsData.shipoutTakebackLimit =
				lockerTimeLimitsData.shipoutTakebackLimit === ""
					? 0
					: lockerTimeLimitsData.shipoutTakebackLimit;

			createLockerTimeLimits({ variables: tempLockerTimeLimitsData })
				.then((data) => {
					if (data) {
						setValidation({
							icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
							title: "Success",
							message: "Successfully created locker time limits.",
							open: true,
							actions: (
								<div className="grid grid-cols-1">
									<Button
										onClick={() => {
											setValidation({ open: false });
											setEditingDone(false);
											setChangesMade(false);
											setIsSuccess(true);
											refetch();
										}}
										value={"OK"}
										className={"p-2"}
									/>
								</div>
							),
						});
						setInitialLockerTimeLimit(tempLockerTimeLimitsData);
						dispatch(setLockerTimeLimitsData(tempLockerTimeLimitsData));
						// refetch();
					}
				})
				.catch((error) => {
					console.error({ error });
				});
		} else {
			let tempLockerTimeLimitsData = { ...lockerTimeLimitsData };
			delete tempLockerTimeLimitsData.__typename;

			tempLockerTimeLimitsData.partnerTypeId = searchCriteria.partnerTypeId;

			// tempLockerTimeLimitsData.operatorId = searchCriteria.operatorId;
			// tempLockerTimeLimitsData.lockerTypeId = searchCriteria.lockerTypeId;
			// tempLockerTimeLimitsData.partnerTypeId = searchCriteria.partnerTypeId;

			//
			if (lockerTimeLimitsData.lockerPartnerLimitId === "") {
				tempLockerTimeLimitsData.lockerPartnerLimitId = 0;
			}
			updateLockerTimeLimits({ variables: tempLockerTimeLimitsData })
				.then((data) => {
					setValidation({
						icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
						title: "Success",
						message: "Successfully updated locker time limits.",
						open: true,
						actions: (
							<div className="grid grid-cols-1">
								<Button
									onClick={() => {
										setValidation({ open: false });
										setEditingDone(false);
										setChangesMade(false);
										setIsSuccess(true);
										refetch();
									}}
									value={"OK"}
									className={"p-2"}
								/>
							</div>
						),
					});

					setInitialLockerTimeLimit(tempLockerTimeLimitsData);
					dispatch(setLockerTimeLimitsData(tempLockerTimeLimitsData));
				})
				.catch((e) => {
					console.error(e);

					if (
						e.message.includes(
							`duplicate key value violates unique constraint "locker_partner_limits__locker_partner"`
						)
					) {
						setValidation({
							icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
							title: "Error",
							message: "Duplicate value found.",
							open: true,
							actions: (
								<div className="gap-2 w-full mx-auto">
									<Button
										onClick={() => setValidation({ open: false })}
										value={"OK"}
										className={"p-2 w-full"}
									/>
								</div>
							),
						});
					}
				});
		}
	};

	const handleCancelChanges = () => {
		setValidation({
			open: false,
		});
		setEditingDone(false);
		setChangesMade(false);
		dispatch(clearLockerTimeLimitChanges(initialLockerTimeLimit));
	};
	//Use effects
	React.useEffect(() => {
		if (lockerTypes.data) {
			let tempData = [];
			lockerTypes.data.lockerTypes.forEach((element) => {
				tempData.push({
					value: element.lockerTypeId,
					name: element.lockerType,
				});
			});
			dispatch(getLockerTypeList(tempData));
		}
	}, [lockerTypes.data]);
	React.useEffect(() => {
		if (partnerTypes.data && searchCriteria.lockerTypeId === "-1") {
			let tempData = [];
			partnerTypes.data.partnerTypes.forEach((element) => {
				tempData.push({
					value: element.partnerTypeId,
					name: element.partnerType,
				});
			});
			dispatch(getPartnertTypeList(tempData));
		} else {
		}
	}, [partnerTypes.data]);

	console.log({ searchCriteriaData });
	return (
		<ContentContainer containerTitle={"Locker Time Limits"}>
			<div className="grid grid-cols-4 gap-2 w-2/3 pb-5">
				<p className="my-auto">Locker Type:</p>
				<Select
					className={"col-span-2"}
					items={lockerTypeList}
					disabled={changesMade}
					name="lockerTypeId"
					value={searchCriteriaData.lockerTypeId.value}
					onChange={handleChangeCriteriaValue}
					defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
				/>
				<div></div>
				<p className="my-auto">Partner Category:</p>
				<Select
					className={"col-span-2"}
					items={partnerCategoryList}
					value={searchCriteria.partnerCategory}
					name="partnerCategory"
					onChange={handleChangeCriteriaValue}
					defaultOption={{ value: "-1", name: "-- Select Partner Category --" }}
				/>
				<div></div>

				<p className="my-auto">Partner Type:</p>
				<Select
					className={"col-span-2"}
					items={filteredPartnerTypeByCategory}
					value={searchCriteria.partnerTypeId}
					disabled={searchCriteria.partnerCategory === "-1" || changesMade}
					name="partnerTypeId"
					onChange={handleChangeCriteriaValue}
					defaultOption={{ value: "-1", name: "-- Select Partner Type --" }}
				/>
				{/* search button */}
				<Button
					className={"p-2"}
					disabled={searchCriteria.partnerTypeId === "-1"}
					value={"Search"}
					onClick={handleSearchLockerTimeLimits}
				/>
			</div>
			{/* */}
			{searchFlag && valueChanged && (
				<>
					<Card className="bg-primary-primaryYellowLight">
						<div className="mt-4 bg-[#F8FAFC] w-full p-4 rounded-sm">
							<span className="font-bold text-black text-center text-lg flex items-center justify-center">
								{searchCriteriaData.lockerTypeId} Locker +{" "}
								{searchCriteriaData.partnerTypeId} Partner
							</span>
							<p className="font-bold text-center">MAX LIMIT OF HOURS</p>
							<p className="text-center">(from time package is in locker)</p>
							<p>
								* All time limits are computed from time of Dropoff in Locker.
							</p>
							<LockerTimeLimitTable
								disabled={
									accessPermission.lockerTimeLimits === 1 ||
									accessPermission.lockerTimeLimits === "1"
								}
								valueChanged={valueChanged}
								// localLockerTimeLim={localLockerTimeLim}
								// setLockerLocalTimeLim={setLockerLocalTimeLim}
								isSuccess={success}
								setIsSuccess={setIsSuccess}
								refetch={refetch}
								editingDone={editingDone}
								setEditingDone={setEditingDone}
								data={lockerTimeLimitsData}
								handleChange={handleChangeLockerTimeLimits}
							/>

							<div className="w-full grid grid-cols-2 gap-8 my-4">
								<Button
									className={`p-2 ${editingDone ? "" : "hidden"}`}
									value="Cancel"
									disabled={
										accessPermission.lockerTimeLimits === 1 ||
										accessPermission.lockerTimeLimits === "1"
									}
									onClick={() => {
										setValidation({
											icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
											title: "Cancel changes",
											message: "Are you sure you want to cancel changes?",
											open: true,
											actions: (
												<div className="grid grid-cols-2 gap-2">
													<Button
														onClick={() => setValidation({ open: false })}
														value={"No"}
														className={"p-2"}
													/>
													<Button
														onClick={handleCancelChanges}
														value={"Yes"}
														className={"p-2"}
													/>
												</div>
											),
										});
									}}
								/>
								<Button
									className={`p-2 ${editingDone ? "" : "hidden"}`}
									value="Save Changes"
									disabled={
										accessPermission.lockerTimeLimits === 1 ||
										accessPermission.lockerTimeLimits === "1"
									}
									onClick={() => {
										setValidation({
											icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
											title: "Save changes",
											message: "Are you sure you want to save changes?",
											open: true,
											actions: (
												<div className="grid grid-cols-2 gap-2">
													<Button
														onClick={() => setValidation({ open: false })}
														value={"No"}
														className={"p-2"}
													/>
													<Button
														onClick={handleSaveChanges}
														value={"Yes"}
														className={"p-2"}
													/>
												</div>
											),
										});
									}}
								/>
							</div>
						</div>
					</Card>
				</>
			)}
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</ContentContainer>
	);
}
